/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.29",
    versionName: "0.2.0-nightly.2025.7.29",
    versionChannel: "nightly",
    buildDate: "2025-07-29T00:08:41.360Z",
    commitHash: "4d53ca1b8f6fbd48032fe4459c3486a021b28af4",
};
